/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vexed_Royal_Jay_MopInputs */

const en_vexed_royal_jay_mop = /** @type {(inputs: Vexed_Royal_Jay_MopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Templates`)
};

const de_vexed_royal_jay_mop = /** @type {(inputs: Vexed_Royal_Jay_MopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagen verwalten`)
};

/**
* | output |
* | --- |
* | "Manage Templates" |
*
* @param {Vexed_Royal_Jay_MopInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vexed_royal_jay_mop = /** @type {((inputs?: Vexed_Royal_Jay_MopInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vexed_Royal_Jay_MopInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vexed_royal_jay_mop(inputs)
	return de_vexed_royal_jay_mop(inputs)
});